import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import Header from '../../common/Header';
import RepeatersNEET from './RepeatersNEET';
import DetailAutoPopUp from './DetailAutoPopUp';

const CoursesHomepage = () => {
  useEffect(() => {
    // Scroll to top when the page/component loads
    window.scrollTo(0, 0);
  }, []);

  const [isAutoPopupOpen, setIsAutoPopupOpen] = useState(false);
      const handleOpenAutoPopup = () => {
          const formSubmitted = sessionStorage.getItem("isFormSubmited");
          if (!formSubmitted) {
              setIsAutoPopupOpen(true);
          }
      };
  
      const handleCloseAutoPopup = () => {
          setIsAutoPopupOpen(false);
      };
  
      useEffect(() => {
          const timeout = setTimeout(() => {
              handleOpenAutoPopup();
          }, 15000);
  
          return () => clearTimeout(timeout)
      }, [])


  return (
    <Grid>
      <Header />
      <Grid>
        <RepeatersNEET />
      </Grid>

      <DetailAutoPopUp
                isOpen={isAutoPopupOpen}
                onClose={handleCloseAutoPopup}
                leadFlag="Organic"
            />

    </Grid>
  );
};

export default CoursesHomepage;
